
const m = window.require("discourse/components/user-status-message");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
